import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

(function () {

    const sliders = document.querySelectorAll('.slider.swiper');
    if (sliders) {
        sliders.forEach((element) => {
            const nextButton = element.querySelector('.swiper-button-next');
            const prevButton = element.querySelector('.swiper-button-prev');
            new Swiper(element, {
                modules: [Navigation],
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                }
            });
        })
    }

})();